import { render, staticRenderFns } from "./punching.vue?vue&type=template&id=1bf3dda3&scoped=true&"
import script from "./punching.vue?vue&type=script&lang=js&"
export * from "./punching.vue?vue&type=script&lang=js&"
import style0 from "./punching.vue?vue&type=style&index=0&id=1bf3dda3&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3dda3",
  null
  
)

export default component.exports